import React from "react";
import { LANDING } from "@/constants/testIds";

// Hand-drawn-style monochrome wordmarks rendered with SVG — no external logo
// assets needed and they sit comfortably with the brand palette.
const Mark = ({ children }) => (
  <span className="font-display text-2xl md:text-3xl tracking-tight text-foreground/70 whitespace-nowrap">
    {children}
  </span>
);

const partners = [
  <Mark key="0">
    NoblePath <span className="font-light italic">Financial</span>
  </Mark>,
  <Mark key="1">NORTHWIND</Mark>,
  <Mark key="2">
    fern&amp;<span className="italic font-light">co</span>
  </Mark>,
  <Mark key="3">
    ▲ ATLAS<span className="text-accent">/</span>WORKS
  </Mark>,
  <Mark key="4">Halverson Bros.</Mark>,
  <Mark key="5">
    HEARTH <span className="font-light">studio</span>
  </Mark>,
  <Mark key="6">
    M<span className="italic">é</span>tier
  </Mark>,
  <Mark key="7">CEDAR &amp; OAK</Mark>,
  <Mark key="8">
    Brightline<span className="text-accent">·</span>Co
  </Mark>,
];

export default function TrustStrip() {
  const loop = [...partners, ...partners];
  return (
    <section
      data-testid={LANDING.trustMarquee}
      className="border-y border-border bg-secondary/40"
    >
      <div className="px-6 md:px-12 lg:px-24 py-10 flex flex-col md:flex-row md:items-center gap-6">
        <p className="label-eyebrow shrink-0 md:max-w-[10rem]">
          Trusted by 110+ owner-led businesses
        </p>
        <div className="relative overflow-hidden flex-1">
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-secondary/70 to-transparent z-10" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-secondary/70 to-transparent z-10" />
          <div className="flex gap-16 animate-marquee w-max">
            {loop.map((p, i) => (
              <div
                key={i}
                className="flex items-center gap-16"
                aria-hidden={i >= partners.length || undefined}
              >
                {p}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
